module.exports = __webpack_public_path__ + "img/success.ad57b1eb.svg";